import type { AxiosInstance } from 'axios';
import { Result } from 'services/Result';
import { injectable } from 'inversify';
import { IVideoUploadProvider } from 'interfaces/providers/IVideoUploadProvider';
import { IVideoAvailability } from 'interfaces/tagging/ApiModels/IVideoAvailability';

@injectable()
export class VideoUploadService implements IVideoUploadProvider {
  private axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  async getAvailability(): Promise<IVideoAvailability> {
    const response = await this.axiosInstance.get<Result<IVideoAvailability>>(`api/videoupload/Availability`);
    if (response.status === 200 && response.data) {
      const r = response.data.data as IVideoAvailability;
      return r;
    }
    throw new Error(`Error getting if video upload can be enabled: ${response.status}`);
  }
}
